import { useUser } from '@clerk/clerk-react';

// Infer user type from useUser hook return type
type ClerkUserReturn = ReturnType<typeof useUser>;
type ClerkUser = ClerkUserReturn['user'];

export interface UseAuthReturn {
  user: ClerkUser;
  isLoaded: boolean;
  isSignedIn: boolean | undefined;
  userId: string | undefined;
  email: string | undefined;
}

export function useAuth(): UseAuthReturn {
  const { user, isLoaded, isSignedIn } = useUser();

  return {
    user,
    isLoaded,
    isSignedIn,
    userId: user?.id,
    email: user?.primaryEmailAddress?.emailAddress,
  };
}
